import React from 'react';
import { Alert, AlertTitle, Chip } from '@mui/material';
import { useSaison } from '../../hooks/SaisonContext';

/** Wegklickbarer Satz. Verdeckt keine Bedienelemente und schreibt nichts in die Fachdaten. */
const SaisonHinweis: React.FC = () => {
  const { copy, dismiss } = useSaison();
  if (!copy) return null;

  return (
    <Alert severity="info" sx={{ mb: 2 }} onClose={dismiss}>
      <AlertTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {copy.zeichen} {copy.label}
        <Chip label="Saison" size="small" color="secondary" />
      </AlertTitle>
      {copy.hinweis}
    </Alert>
  );
};

export default SaisonHinweis;
